'use client';
import { useEffect, useRef } from "react";

export default function ZoomInWrapper({ children, className = "", delay = 0, duration = 0.8 }) {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const target = entry.target;
            target.style.animation = `zoomIn ${duration}s ease-out ${delay}s forwards`;
            observer.unobserve(target);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [delay, duration]);

  return (
    <div ref={sectionRef} className={`opacity-0 transform scale-100 ${className}`}>
      {children}
    </div>
  );
}
